import {Input, Select, Spin, Typography} from "antd";
import {usePDGeothermal} from "../../hooks/usePDGeothermal";
import {useState} from "react";
import {InteractionData} from "../Tooltip";
import {Content} from "antd/es/layout/layout";
import {ScatterplotBasicDemo} from "../ScatterplotBasicDemo";
import {CALCULATED_FUNCTIONS} from "../../utils/consts";

// const countryList = [
// 		{ value: '', label: 'All' },
// 		{ value: 'Montserrat', label: 'Montserrat' },
// 		// Add more countries as needed
// ];

export const PDGeothermal = () => {
		const {
			// data,
			calculatedData,
			loading,
			setWellsAmount,
			wellsAmount,
			// setData,
			geothermalPercent,
			setGeothermalPercent,
			calculatedFunction,
			setCalculatedFunction,
			// fetchData
		} = usePDGeothermal();
		const [hovered, setHovered] = useState<InteractionData | null>(null);
		// const [location , setLocation] = useState<string>("");

		return (
			<Content style={{
					padding: '0 24px',
					minHeight: "100%",
					display: "flex",
					flexDirection: "column",
					overflow: 'scroll'
			}}>
					<h1 style={{ color: 'var(--navy)', fontSize: '28px', fontWeight: 700, margin: '24px 0 16px', width: '100%', textAlign: 'left' }}>Geothermal Production</h1>

					{/* Controls panel */}
					<div className="va-controls-panel">
						<div className="va-control-group">
							<span className="va-control-label">Geothermal Percent</span>
							<Input
								type="number"
								defaultValue={geothermalPercent}
								value={geothermalPercent}
								style={{width: 120}}
								onChange={(e) => {
									const value = e.target.value;
									const numericValue = parseFloat(value);
									if (!value || isNaN(numericValue) || numericValue < 0) {
										setGeothermalPercent(0);
										return;
									}
									if (numericValue > 100) {
										setGeothermalPercent(100);
										return;
									}
									setGeothermalPercent(numericValue);
								}}
							/>
						</div>
						<div className="va-control-group">
							<span className="va-control-label">Calculated Function</span>
							<Select
								value={calculatedFunction}
								onChange={(value) => {
									setCalculatedFunction(value);
								}}
								options={CALCULATED_FUNCTIONS.map((item) => ({value: item, label: item}))}
							/>
						</div>
						<div className="va-control-group">
							<span className="va-control-label">Wells Amount</span>
							<Input
								defaultValue={wellsAmount}
								value={wellsAmount}
								style={{width: 120}}
								//@ts-ignore
								onChange={(e) => setWellsAmount(e.target.value)}
							/>
						</div>
					</div>

					{/* Chart */}
					<Spin spinning={loading} size="large" style={{width: '100%'}}>
					<div className="chart-frame">
							{
								calculatedData &&
                  <ScatterplotBasicDemo data={calculatedData} width={700} height={400} hovered={hovered} setHovered={setHovered} wellsAmount={wellsAmount}/>
							}
							{/*<div style={{display: "flex", flexDirection: "column", width: "100%", paddingLeft: "10px"}}>*/}
							{/*		<div style={{color: "#3a3a3a", fontSize: "80px"}}>*/}
							{/*				**/}
							{/*		</div>*/}
							{/*		{	hovered &&*/}
							{/*				<div style={{width: "100%", paddingLeft: "10px"}}>*/}
							{/*				<div style={{fontSize: "20px"}}>*/}
							{/*					 	<Typography.Text >Element name: <Typography.Text strong>{hovered?.name || ""} </Typography.Text></Typography.Text>*/}
							{/*						<br></br>*/}
							{/*						<Typography.Text>World consumption (Ton/Year): <Typography.Text strong>{hovered?.worldConsumption.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")  || ""}</Typography.Text></Typography.Text>*/}
							{/*						<br></br>*/}
							{/*						<Typography.Text>Model well production (Ton/Year): <Typography.Text strong>{hovered?.wellProduction.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")  || ""}</Typography.Text></Typography.Text>*/}
							{/*						<br></br>*/}
							{/*						<Typography.Text>Price USD/Ton:<Typography.Text strong> {hovered?.cost.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")  || ""}</Typography.Text></Typography.Text>*/}
							{/*						<br></br>*/}
							{/*						<Typography.Text>distance to*/}
							{/*								x=y: <Typography.Text strong>{hovered ? -(hovered?.x - hovered?.y).toFixed(2) : ""}</Typography.Text></Typography.Text>*/}
							{/*				</div>*/}
							{/*		</div>*/}
							{/*		}*/}
							{/*</div>*/}
					</div>
					</Spin>
					{/*<Typography.Text style={{alignSelf: "start", color: "#3a3a3a", paddingLeft: "5%"}}>*/}
					{/*		* - means that the consumption data is not fully reliable as it excludes US or China production data or*/}
					{/*		estimated roughly.*/}
					{/*		<br/>*/}
					{/*		⁃ Data on world consumption is taken from the USGS Commodities Summary 2024.*/}
					{/*		<br/>*/}
					{/*		⁃ Data on the element concentration in geothermal wells is taken from the Argonne Database.*/}
					{/*		<br/>*/}
					{/*		⁃ Model well has average concentration of the top 1% of the wells from the database*/}
					{/*		<br/>*/}
					{/*		⁃ The production rate of 100000 Mt per day is assumed.*/}
					{/*		<br/>*/}
					{/*		⁃ 100% recovery rate is assumed in these calculations.*/}

					{/*</Typography.Text>*/}
					{/*<Slider*/}
					{/*	range*/}
					{/*	defaultValue={[2024, 2025]}*/}
					{/*	min={2023}*/}
					{/*	max={2026}*/}
					{/*	style={{width: "50%"}}*/}
					{/*	marks={{*/}
					{/*			2023: "2023",*/}
					{/*			2026: "2026",*/}
					{/*	}}/>*/}
			</Content>
		)
}